<template>
  <v-list-item>
    <slot name="icon"></slot>
    <v-list-item-content>
      <v-list-item-title class="text-truncate">
        <a v-if="hasOpenDetailListener()" @click.stop="emitOpenDetail"> #{{ item.number }} {{ item.title || "-" }} </a>
        <span v-else> #{{ item.number }} {{ item.title || "-" }} </span>
        <span>
          <v-chip x-small class="mx-1" :color="item.state === HandoverStateEnum.OPEN ? 'success' : ''">
            {{ $t("objects.handover.states." + item.state) }}
          </v-chip>
        </span>
      </v-list-item-title>
      <v-list-item-subtitle class="text-xs" v-if="!small && companies.length">
        <v-icon x-small>mdi-domain</v-icon>
        {{ companies.join(", ") }}
      </v-list-item-subtitle>
      <v-list-item-subtitle class="text-xs" v-if="!small && names.length">
        <v-icon x-small>mdi-account</v-icon>
        {{ names.join(", ") }}
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script lang="ts">
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { GoToHelper } from "@/lib/utility/goToHelper";
import { Component, Prop, Vue } from "vue-property-decorator";
import { IRefDetail } from "./RefsList.vue";
import Tooltip from "./tooltip.vue";
import { IHandover } from "@/models/handover.entity";
import { HandoverStateEnum } from "@/lib/enum/handover-state.enum";

@Component({
  components: { Tooltip },
  filters: { simpleDoubleDigitDate }
})
export default class RefsHandover extends Vue implements IRefDetail<IHandover> {
  @Prop()
  item!: IHandover;

  @Prop({ default: false })
  small!: boolean;

  confirmable = false;

  goToDetail(openInNew = true) {
    new GoToHelper(this.$router).goToHandoverDetail(this.item.id, this.item.partnerId, openInNew);
  }

  hasOpenDetailListener() {
    return Boolean(this.$listeners && this.$listeners.openDetail);
  }

  emitOpenDetail() {
    this.$emit("openDetail", this.item);
  }

  get HandoverStateEnum() {
    return HandoverStateEnum;
  }

  get names() {
    const names = [];

    for (const attendee of this.item.attendees) {
      names.push(attendee.email);
    }

    return names;
  }

  get companies() {
    const names = [];

    for (const company of this.item.parties) {
      if (company?.companyName) {
        names.push(company.companyName);
      }
    }

    return names;
  }
}
</script>
